module.exports = __webpack_public_path__ + "static/media/Background_Startseite_Studenten.a265ba8d.jpg";